import React, { ComponentState, useEffect, useRef, useState } from 'react';
import { AppButtons } from '../../../../../components/button';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { CustomInput } from '../../../../../components/Input';
import { ErrorConsts } from '../../../../../utils/ErrorCons';
import { GenericResponseModel } from '../../../../../dataModel/authModels';
import { doc } from '../../../../../services/docuemnt';
import { AppyDocPostObj } from '../../../../../dataModel/documentModels';
import { saveSignedDocResponse } from '../../../../../redux/actions';

export interface ViewDocProps {
  url: string
  docId: number
  cancelClick(): void
  isSignedDoc: boolean
  isLocked: boolean
  isClientFillable?: boolean
}

const ViewDocumentFrame = (props: ViewDocProps) => {


  const [loading, setLoading] = useState(false);
  const state: ComponentState = useSelector(states => {
    return states;
  });
  const [buttonPressed, setButtonPressed] = useState(false)
  const [isParent, setIsParent] = useState(false)
  const [isStartedSaveDoc, setIsStartedSaveDoc] = useState(false)
  const [pin, setPin] = useState('')
  const [iFrameUri, setIframeUri] = useState(props.url)
  const [signatureDate, setSigDate] = useState<string>('');
  const [pinValidationError, setPinValidationError] = useState(false)
  const [isSigned, setIsSigned] = useState(props.isSignedDoc)
  const { authClientDetailedInfo, } = state['AuthReducer'];
  const dispatch = useDispatch()
  const iframeRef: any = useRef(null);


  useEffect(() => {
    validatePin(pin)
  }, [pin])

  const handleValidation = () => {
    let formIsValid = true;
    setButtonPressed(true)
    if (pin.length < 4 || pinValidationError) {
      formIsValid = false;
    }
    if (!signatureDate || signatureDate.length < 1) {
      formIsValid = false;
    }
    // if (!signatureTime || signatureTime.length < 1) {
    //   formIsValid = false;
    // }

    return formIsValid;
  };

  const validatePin = async (pinCode: string) => {
    setPinValidationError(false)
    if (pinCode.length > 3) {
      setLoading(true);
      const validateResp: GenericResponseModel = await doc.validatePins(`isParentSig=${isParent}&pin=${pinCode}`)
      setPinValidationError(!validateResp.status)
      setLoading(false);
    }
  };



  const sendMessageToIframe = () => {
    if (!isStartedSaveDoc) {
      setIsStartedSaveDoc(true)
      iframeRef.current?.contentWindow?.postMessage({ type: "SAVE_DOCUMENT" }, "*");
    }
  };


  const applySign = async () => {
    const preDate = new Date(signatureDate);

    if (!handleValidation()) return;

    const myReqObj: AppyDocPostObj = {
      id: props.docId,
      isParent: isParent,
      pin: pin,
      signatureType: 2,
      sigDateTime: preDate,
      clientId: authClientDetailedInfo.clientId
    };

    setLoading(true);

    const validateResp: GenericResponseModel = await doc.applySign(myReqObj);

    setLoading(false);
    setIsStartedSaveDoc(false);

    if (validateResp?.status) {
      props.cancelClick();
      dispatch(saveSignedDocResponse(validateResp));
      setIsSigned(true);
      setIframeUri(props.url);
    }
  }



  const saveDocAndApplySign = async () => {
    const preDate = new Date(signatureDate);

    if (!handleValidation()) return;

    const onMessage = async (event: any) => {

      if (event.data?.type === "SAVE_RESULT") {
        window.removeEventListener("message", onMessage);

        const isSuccess = event.data.success;

        if (!isSuccess) {
          setIsStartedSaveDoc(false);
          return;
        }

        const myReqObj: AppyDocPostObj = {
          id: props.docId,
          isParent: isParent,
          pin: pin,
          signatureType: 2,
          sigDateTime: preDate,
          clientId: authClientDetailedInfo.clientId
        };

        setLoading(true);

        const validateResp: GenericResponseModel = await doc.applySign(myReqObj);

        setLoading(false);
        setIsStartedSaveDoc(false);

        if (validateResp?.status) {
          props.cancelClick();
          dispatch(saveSignedDocResponse(validateResp));
          setIsSigned(true);
          setIframeUri(props.url);
        }
      }
    };

    window.addEventListener("message", onMessage);
    sendMessageToIframe();
  };



  useEffect(() => {
    const handler = (event: any) => {
      try {
        const data = JSON.parse(event?.data)
        if (data && data.error === false && data.message === 'FillableDoc') {
          props.cancelClick()
        }
      } catch (err) {
        return;
      }
    }

    window.addEventListener("message", handler)

    // clean up
    return () => window.removeEventListener("message", handler)
  }, [])


  return (


    <div onContextMenu={(e) => e.preventDefault()} className="modal-wrapper largeModalDoc">
      <div className="modal-Div my-3">
        <button className="close-btn">
          <i className="fa-regular fa-circle-xmark" onClick={() => { props.cancelClick() }}></i>
        </button>
        <div className='pt-3'>

          <iframe
            src={iFrameUri}
            ref={iframeRef}
            sandbox="allow-scripts allow-same-origin"
            className='bg-white modalIframe'>
          </iframe>


          {(!isSigned && !props.url.endsWith('updateDoc')) && <div>
            {/* <h4 className="mt-4 mb-2 fw-600">{'Apply Signature'}
            </h4> */}
            <div className="row align-items-start formBottom-0  mt-4">

              <div className="col-md-4 col-12 labelMargin" >
                <FormControl>
                  {/* <FormLabel id="demo-radio-buttons-group-label" className="mb-0">Signature Type</FormLabel> */}
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="client"
                    name="radio-buttons-group"
                  >
                    <div className="d-flex mb-2  gap-2 flex-wrap">
                      <FormControlLabel onClick={() => { setIsParent(false) }} value="client" control={<Radio />} label="Sign by Client" />
                      <FormControlLabel onClick={() => { setIsParent(true) }} value="parent" control={<Radio />} label="Sign by Parent" />
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="col-md-3 col-12 labelMargin" >
                <CustomInput
                  id="date"
                  labelText="Signature Date"
                  inputType="date"
                  onChange={(event: any) => {
                    setSigDate((event.target.value))
                  }}
                  value={signatureDate}
                  showError={(buttonPressed && (!signatureDate || signatureDate == null))}
                  errorMessage={ErrorConsts.FIELD_BLANK}
                />
              </div>

              <div className="col-md-3 col-12  labelMargin" >
                <CustomInput
                  id="pin"
                  labelText="Enter Sig Pin"
                  inputType="number"
                  inputProps={{ pattern: "[0-9]*" }}
                  onChange={(event: any) => {
                    setPin(event.target.value)
                  }}
                  onInput={(e: any) => {
                    const value = e.target.value;
                    const numericValue = value.replace(/[^0-9]/g, '');
                    e.target.value = numericValue.slice(0, 4);
                  }}
                  showError={pinValidationError || (buttonPressed && (!pin || pin.length < 4))}
                  errorMessage={pinValidationError ? ErrorConsts.INVALID_PIN : ErrorConsts.PIN}
                />

              </div>

              <div className="col-md-2 col-12   labelMargin" >

                <AppButtons buttonText="Save & Apply Signature"
                  className="btn-common  btn-green "
                  onclick={() => {
                    if (props?.isLocked || props?.isClientFillable === false) {
                      applySign();
                    } else {
                      saveDocAndApplySign();
                    }
                  }}
                  loadingState={loading || isStartedSaveDoc}></AppButtons>
              </div>
            </div>


          </div>}
        </div>
      </div>
    </div>
    // </div>
  );
}

export default ViewDocumentFrame;